var module = angular.module('octopusApp.certificates');

module.directive('certificateVariableSelect', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'areas/certificates/select/certificate_variable_select.html',
        scope: {
            project: '=',
            model: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: function (busy, octopusRepository, variableTypes, $q) {
            var vm = this;
            vm.isLoading = busy.create();
            vm.availableVariables = [];
            vm.refresh = loadVariables;

            function loadVariables() {

                var templates = [];

                vm.isLoading.promise($q.all(vm.project.IncludedLibraryVariableSetIds.map(function (libraryVariableSetId) {
                        return octopusRepository.LibraryVariableSets.get(libraryVariableSetId);
                    })).then(function (libraryVariableSets) {
                        templates = _.union(vm.project.Templates, _.flatten(libraryVariableSets.map(function (lvs) {
                            return lvs.Templates;
                        }), true))
                            .filter(function(template){
                                return !!template.DisplaySettings && template.DisplaySettings['Octopus.ControlType'] === 'Certificate';
                            });

                        var variableSetIds = _.union([vm.project.VariableSetId], libraryVariableSets.map(function (lvs) {
                            return lvs.VariableSetId;
                        }));

                        return $q.all(variableSetIds.map(function (variableSetId) {
                            return octopusRepository.Variables.get(variableSetId).then(function(vs){
                                return vs.Variables;
                            });
                        }));
                    }).then(function (variableResults) {
                        var variables = _.flatten(variableResults, true)
                            .filter(function (v) {
                                return v.Type === variableTypes.certificate().name;
                            });

                        vm.availableVariables = _.chain(variables)
                            .union(templates)
                            .map(function (v) {
                                return v.Name;
                            })
                            .uniq()
                            .value();
                    })
                );
            }

            loadVariables();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/certificates/select/certificate_variable_select.js
// module id = 1214487222821083
// module chunks = 1